import { render } from "./DividaEdit.vue?vue&type=template&id=2e8d3bc8&scoped=true"
import script from "./DividaEdit.vue?vue&type=script&lang=js"
export * from "./DividaEdit.vue?vue&type=script&lang=js"

import "./DividaEdit.vue?vue&type=style&index=0&id=2e8d3bc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e8d3bc8"]])

export default __exports__